function pad(number) {
  var r = String(number);
  if ( r.length === 1 ) {
    r = '0' + r;
  }
  return r;
}

function getFullUrl(uri) {
  // var getUrl = window.location;
  // var url = getUrl.protocol + "//" + getUrl.host + uri;
  return uri;
}

(function () {
  'use strict';
  /**
  * Override UTC ISO String Conversion
  */
  Date.prototype.toCarbon = function () {
    // avoid UTC conversion
    return this.getFullYear()
    + '-' + pad(this.getMonth() + 1)
    + '-' + pad(this.getDate())
    + ' ' + pad(this.getHours())
    + ':' + pad(this.getMinutes())
    + ':' + pad(this.getSeconds());
  };

  /**
  * Override UTC ISO String Conversion
  */
  Date.prototype.toISOString = function () {
    // avoid UTC conversion
    return this.getFullYear()
    + '-' + pad(this.getMonth() + 1)
    + '-' + pad(this.getDate())
    + 'T' + pad(this.getHours())
    + ':' + pad(this.getMinutes())
    + ':' + pad(this.getSeconds())
    + '.' + String((this.getMilliseconds() / 1000).toFixed(3)).slice(2, 5)
    + 'Z';
  };
  var _MS_PER_YEAR = 1000 * 60 * 60 * 24 * 365;

  /**
  * Override UTC ISO String Conversion
  */
  Date.prototype.diffInYear = function (b) {
    // Discard the time and time-zone information.
    var utc1 = Date.UTC(this.getFullYear(), this.getMonth(), this.getDate());
    var utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

    return Math.floor((utc2 - utc1) / _MS_PER_YEAR);
  };
}());

function localeDate(inputFormat) {
  var d = new Date(inputFormat);
  return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/');
}

function localeDatetime(inputFormat) {
  var d = new Date(inputFormat);
  return localeDate(inputFormat) + ' ' + [pad(d.getHours()), pad(d.getMinutes()+1)].join(':');
}

if (!Object.keys) {
	Object.keys = (function () {
		'use strict';
		var hasOwnProperty = Object.prototype.hasOwnProperty,
				hasDontEnumBug = !({toString: null}).propertyIsEnumerable('toString'),
				dontEnums = [
					'toString',
					'toLocaleString',
					'valueOf',
					'hasOwnProperty',
					'isPrototypeOf',
					'propertyIsEnumerable',
					'constructor'
				],
				dontEnumsLength = dontEnums.length;

		return function (obj) {
			if (typeof obj !== 'object' && (typeof obj !== 'function' || obj === null)) {
				throw new TypeError('Object.keys called on non-object');
			}

			var result = [], prop, i;

			for (prop in obj) {
				if (hasOwnProperty.call(obj, prop)) {
					result.push(prop);
				}
			}

			if (hasDontEnumBug) {
				for (i = 0; i < dontEnumsLength; i++) {
					if (hasOwnProperty.call(obj, dontEnums[i])) {
						result.push(dontEnums[i]);
					}
				}
			}
			return result;
		};
	}());
}

// Simple but unreliable function to create string hash by Sergey.Shuchkin [t] gmail.com
// alert( strhash('http://www.w3schools.com/js/default.asp') ); // 6mn6tf7st333r2q4o134o58888888888
function strhash( str ) {
    if (str.length % 32 > 0) str += Array(33 - str.length % 32).join("z");
    var hash = 'k', bytes = [], i = j = k = a = 0, dict = ['a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','1','2','3','4','5','6','7','8','9'];
    for (i = 0; i < str.length; i++ ) {
        ch = str.charCodeAt(i);
        bytes[j++] = (ch < 127) ? ch & 0xFF : 127;
    }
    var chunk_len = Math.ceil(bytes.length / 32);
    for (i=0; i<bytes.length; i++) {
        j += bytes[i];
        k++;
        if ((k == chunk_len) || (i == bytes.length-1)) {
            a = Math.floor( j / k );
            if (a < 32)
                hash += '0';
            else if (a > 126)
                hash += 'z';
            else
                hash += dict[  Math.floor( (a-32) / 2.76) ];
            j = k = 0;
        }
    }
    return hash;
}

function SecToHM( in_secs ) {
    var sec_num = parseInt(in_secs, 10); // don't forget the second param
    var hours   = Math.floor(sec_num / 3600);
    var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    //var seconds = sec_num - (hours * 3600) - (minutes * 60);

    var value = '';
    if( hours ) {
    	value = hours + 'h';
    }
    if( minutes ) {
    	value += ' ' + minutes + 'min';
    }

    return value;
}
